import { FC, useCallback, useContext } from "react";
import { OrganizationContext } from "../../../../../organizations/common/organization-provider/organization-provider";
import Button from "antd/es/button";
import Empty from "antd/es/empty";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/pro-regular-svg-icons/faExternalLinkAlt";
import { BillingPortalSessionFlowType } from "constellation-sdk";
import { ButtonContainer, EmptyContainer } from "./invoices-view.styled";

type InvoicesViewProps = {
	organizationId: string
}

export const InvoicesView: FC<InvoicesViewProps> = ({
	organizationId,
}) => {

	// context
	const { openCustomerBillingPortal } = useContext(OrganizationContext)

	// event handlers
	const handleOpenPortalClick = useCallback(() => {
		openCustomerBillingPortal(BillingPortalSessionFlowType.none)
	}, [openCustomerBillingPortal])

    return (
		<EmptyContainer>
			<Empty
				description="You can view your invoices in the Customer Billing Portal"
			>
				<ButtonContainer>
					<Button
						type="primary"
						icon={<FontAwesomeIcon icon={faExternalLinkAlt} />}
						onClick={handleOpenPortalClick}
					>
						Open Customer Billing Portal
					</Button>
				</ButtonContainer>
			</Empty>
		</EmptyContainer>
	)
}